import {getCapability} from '../../capabilities';

export function hasEmailSequenceCapability(): boolean {
    return getCapability('emailSequences').isAvailable;
}
